import CriteoDataLayerReporter from './criteoDataLayerReporter';

export default CriteoDataLayerReporter;
